import { JSX, useCallback, useState } from "react";

import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IFilterAccordionItem {
    name: string;
    children?: JSX.Element | JSX.Element[] | null;
}
function FilterAccordionItem({ name, children }: IFilterAccordionItem) {
    const [show, setShow] = useState(false);
    const handleToogle = useCallback(() => {
        setShow(s => !s);
    }, []);
    return (
        <>

            <div className='filterListItem' onClick={handleToogle}>
                <div className='title'>
                    {name}
                </div>
                <div className='action'>
                    <FontAwesomeIcon icon={show ? faChevronDown : faChevronRight} />
                </div>
            </div>
            {
                show
                && <div className="filterInnerWrap">
                    {children}
                </div>
            }
        </>
    );
}

export default FilterAccordionItem;
